import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { ModalContainer } from "../Modal/components/ModalContainer.js";
import { ModalHeader } from "../Modal/components/ModalHeader.js";
import { Modal } from "../Modal/Modal.js";
const drawer = "_drawer_1p2s7_3";
const drawerHeader = "_drawerHeader_1p2s7_23";
const drawerContainer = "_drawerContainer_1p2s7_36";
const drawerOverlayEntering = "_drawerOverlayEntering_1p2s7_45";
const drawerOverlayExiting = "_drawerOverlayExiting_1p2s7_49";
const drawerEntering = "_drawerEntering_1p2s7_54";
const drawerExiting = "_drawerExiting_1p2s7_62";
const styles = {
  drawer,
  drawerHeader,
  drawerContainer,
  drawerOverlayEntering,
  drawerOverlayExiting,
  drawerEntering,
  drawerExiting
};
const Drawer = ({
  children,
  closeButtonDescription,
  isDialog = false,
  isOpen,
  onClose,
  renderIn,
  restoreFocus = true,
  shouldMount = false,
  title,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Modal,
    {
      animationTimeout: 600,
      closeOnBlurOutside: !isDialog,
      focusTrap: isDialog,
      isOpen,
      onClose,
      renderIn,
      restoreFocus,
      shouldMount,
      title,
      transitionStyles: {
        entering: styles.drawerOverlayEntering,
        exiting: styles.drawerOverlayExiting
      },
      children: /* @__PURE__ */ jsxs(
        ModalContainer,
        {
          "aria-label": title,
          component: isDialog ? "div" : "aside",
          className: clsx(styles.drawer, props.className),
          role: isDialog ? "dialog" : void 0,
          transitionStyles: {
            entering: styles.drawerEntering,
            exiting: styles.drawerExiting
          },
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              ModalHeader,
              {
                closeButtonDescription,
                className: styles.drawerHeader,
                children: title
              }
            ),
            /* @__PURE__ */ jsx("div", { className: styles.drawerContainer, children: typeof children === "string" ? /* @__PURE__ */ jsx(Text, { children }) : /* @__PURE__ */ jsx(Fragment, { children }) })
          ]
        }
      )
    }
  );
};
export {
  Drawer
};
